export function currencyConverter(price: string | number | undefined, currencyCode: string = "INR", selectedCurrencyDetails: any = {}, enableCurrencyPrefix: boolean = false): string {
  if (price !== undefined) {
    const numericPrice = typeof price === "string" ? parseFloat(price) : price;
    if (numericPrice < 0) return "";
    if (currencyCode === "INR" || currencyCode === "QAR") {
      const locale = "en-US";
    }
    let locale = "en-US";
    if (currencyCode === "SGD") {
      locale = "en-SG";
    }
    if (enableCurrencyPrefix) {
      const formatter = new Intl.NumberFormat(locale, {
        style: "decimal",
        maximumFractionDigits: selectedCurrencyDetails?.displayDigits,
        minimumFractionDigits: selectedCurrencyDetails?.displayDigits
      });    
      return formatter.format(numericPrice);
    }
    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits: selectedCurrencyDetails?.displayDigits,
      minimumFractionDigits: selectedCurrencyDetails?.displayDigits
    });

    return formatter.format(numericPrice);
  }

  return "";
}
